import { render, staticRenderFns } from "./ContentTabBar.vue?vue&type=template&id=5f56092a&scoped=true&"
import script from "./ContentTabBar.vue?vue&type=script&lang=js&"
export * from "./ContentTabBar.vue?vue&type=script&lang=js&"
import style0 from "./ContentTabBar.vue?vue&type=style&index=0&id=5f56092a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56092a",
  null
  
)

export default component.exports